import React, { useCallback, useState } from 'react'
import classnames from 'classnames'

interface OAuthErrorDetailsProps {
  errorCode: string
}

export const OAuthErrorDetails: React.FC<OAuthErrorDetailsProps> = ({ errorCode }) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const toggle = useCallback(() => {
    setExpanded((prev) => !prev)
  }, [])

  const detailsId = 'oauth-error-details'

  return (
    <div className='mb-4'>
      <button
        type='button'
        className='btn btn-link text-decoration-none p-0 d-flex align-items-center gap-2 text-body oauth-btn-xs'
        onClick={toggle}
        aria-expanded={expanded}
        aria-controls={detailsId}
      >
        <i className={classnames('bi', expanded ? 'bi-chevron-down' : 'bi-chevron-right')} />
        <span className='text-uppercase fw-bold'>Error Details</span>
      </button>
      {expanded && (
        <div id={detailsId} className='bg-light rounded-3 p-3 mt-2 text-muted small'>
          <strong>Error Code:</strong> {errorCode}
        </div>
      )}
    </div>
  )
}
